<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar
        id="navbarGlobal"
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>
        <feather-icon
          v-if="nameColor == 'dark'"
          icon="SunIcon"
          class="cursor-pointer ml-2"
          @click="changeTheme()"
        ></feather-icon>
        <feather-icon
          v-if="nameColor =='light'"
          icon="MoonIcon"
          class="cursor-pointer ml-2"
          @click="changeTheme()"
        ></feather-icon>
        <template v-if="breakpoint != 'md'">
          <!-- STARRED PAGES - FIRST 10 -->
          <ul class="vx-navbar__starred-pages">
            <draggable
              v-model="starredPagesLimited"
              :group="{name: 'pinList'}"
              class="flex cursor-move"
            >
              <li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">
                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                  <feather-icon
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    :icon="page.labelIcon"
                    @click="$router.push(page.url)"
                  ></feather-icon>
                </vx-tooltip>
              </li>
            </draggable>
          </ul>

          <!-- STARRED PAGES MORE -->
          <div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
            <vs-dropdown vs-custom-content vs-trigger-click>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>
              <vs-dropdown-menu>
                <ul class="vx-navbar__starred-pages-more--list">
                  <draggable
                    v-model="starredPagesMore"
                    :group="{name: 'pinList'}"
                    class="cursor-move"
                  >
                    <li
                      class="starred-page--more flex items-center cursor-pointer"
                      v-for="page in starredPagesMore"
                      :key="page.url"
                      @click="$router.push(page.url)"
                    >
                      <feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1" :icon="page.labelIcon"></feather-icon>
                      <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <feather-icon
            icon="ArrowLeftCircleIcon"
            :svgClasses="['stoke-current text-warning', {'text-white': navbarColor != '#fff'}]"
            class="cursor-pointer p-2"
            @click.stop="backToStudentMenu"
            v-if="$route.params.isStudent"
          />
          <p class="cursor-pointer" @click.stop="backToStudentMenu" v-if="$route.params.isStudent">
            <small>Back to Menu</small>
          </p>
        </template>

        <vs-spacer></vs-spacer>

        <feather-icon
          icon="HelpCircleIcon"
          class="cursor-pointer sm:mr-6 mr-2"
          @click="manualShow()"
        ></feather-icon>
        <vs-popup fullscreen title="User Manual" :active.sync="popupActive">
          <iframe
            class="snapiframe"
            onload="this.style.visibility = 'visible';"
            v-bind:src="manualUrl"
            width="100%"
            height="800px"
            style="visibility:hidden;"
          >Your browser does not support iframes.</iframe>
        </vs-popup>

        <!-- NOTIFICATIONS -->
        <vs-dropdown id="notificationDropdown" ref="notificationDropdown" vs-custom-content vs-trigger-click class="cursor-pointer">
          <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length"></feather-icon>
          <vs-dropdown-menu class="notification-dropdown dropdown-custom">
            <div class="cursor-pointer text-right bg-primary text-white" style="position: absolute; right: 20px; top: 27px; z-index: 99999;">
              <feather-icon @click="refresh" icon="RefreshCwIcon" class="cursor-pointer mb-2"></feather-icon>
            </div>
            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
              <p class="opacity-75">Notification(s)</p>
            </div>

            <VuePerfectScrollbar v-show="unreadNotifications.length > 0" ref="mainSidebarPs" class="vs-con-loading__container scroll-area--nofications-dropdown p-0 mb-10" :settings="settings">
              <ul class="bordered-items">
                <li v-for="ntf in unreadNotifications" :key="ntf.id" class="flex justify-between px-4 py-4 notification cursor-pointer">
                  <div class="flex items-start" @click="handleNtfClick(ntf)">
                    <!-- <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon> -->
                    <div class="mx-2">
                      <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.notificationTitle }}</span>
                      <!-- <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span> -->
                      <small>{{ ntf.notificationDescription }}</small>
                    </div>
                  </div>
                  <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdOn) }}</small>
                  <feather-icon v-show="!showCheck" @mouseover="showCheck = true" id="unReadButton" icon="CircleIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2"></feather-icon>
                  <feather-icon v-show="showCheck" @mouseout="showCheck = false" id="readButton" @click.stop.prevent="markSingleAsRead(ntf.id)" icon="CheckCircleIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2"></feather-icon>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div v-if="unreadNotifications.length > 0" @click="markAllAsRead" class="
                checkout-footer
                fixed
                pin-b
                rounded-b-lg
                text-primary
                w-full
                p-2
                font-semibold
                text-center
                border
                border-b-0
                border-l-0
                border-r-0
                border-solid
                border-grey-light
                cursor-pointer">
                <span>Mark All as Read</span>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ user_displayName }}</p>
            <!-- <small>Available</small> -->
          </div>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <img
                v-if="activeUserImg.startsWith('http')"
                key="onlineImg"
                :src="activeUserImg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <img
                v-else
                key="localImg"
                src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </div>
            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <li v-if="$acl.check('Mentor')" class="flex py-2 px-4 cursor-pointer hover:bg-school_primary hover:text-white" @click="moderatorToBackEnd">
                  <span class="mr-4">Go To Mentor</span>
                  <feather-icon class="mb-1 ml-3" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                </li>
                <vs-divider v-if="$acl.check('Mentor')" class="my-1"></vs-divider>
                <div v-show="canChangeSite">
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                    @click="changeSite"
                  >
                    <feather-icon icon="LayersIcon" svgClasses="w-4 h-4"></feather-icon>
                    <span class="ml-2">Change Site</span>
                  </li>
                  <vs-divider class="my-1"></vs-divider>
                </div>
                <div v-if="!($route.name == 'AltProfile' || $route.name == 'StudentProfile' || $route.name == 'Profile')">
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                    @click="viewProfile"
                  >
                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                    <span class="ml-2">View Profile</span>
                  </li>
                  <vs-divider class="my-1"></vs-divider>
                </div>
                <div v-if="$acl.check('Teacher') && $siteTypeId() == 1">
                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changeToTeacher">
                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                    <span class="ml-2">Go To Frontend</span>
                  </li>
                  <vs-divider class="my-1"></vs-divider>
                </div>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout"
                >
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Logout</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
    <vs-popup title="Error List" :active.sync="showBulkStudentValidation">
      <vs-table ref="premiumList" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search :data="bulkUploadRows">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          <!-- ITEMS PER PAGE -->
          <div class="vx-row w-full">
            <div style="margin-left: 20px;" class="vx-col w-full">
              <vs-dropdown  vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/2 xs:w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
                <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                  <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ bulkUploadRows.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : bulkUploadRows.length }} of {{ bulkUploadRows.length }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="tasksPerPage=10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=20">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=25">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=50">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=100">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div style="margin-left: 20px;" class="vx-col w-full">
            </div>
          </div>
        </div>
      
        <template slot="thead">
          <vs-th sort-key="error">Errors</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="row" :key="indextr" v-for="(row, indextr) in data"> 

           <vs-td :data="data[indextr]">
             {{ row }}
           </vs-td> 
      
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-3">
        <vs-button color="warning" class="float-right" @click="closeBulkUploadPopup">close</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import themeConfig from "@/../themeConfig.js";
export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      showCheck: false,
      popupActive: false,
      manualUrl: "",
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      unreadNotifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      canChangeSite: false,
      nameColor:"",
      showBulkStudentValidation:false,
      bulkUploadRows:[],
      currentTaskPage:1,
      tasksPerPage:10,
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
    showBulkStudentValidation:function(){
      if(!this.showBulkStudentValidation){
        this.bulkUploadRows = [];
      }
    }
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "en") return { flag: "us", lang: "English" };
      // else if (locale == "pt") return { flag: "br", lang: 'Portuguese' }
      // else if (locale == "fr") return { flag: "fr", lang: 'French' }
      // else if (locale == "de") return { flag: "de", lang: 'German' }
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      }
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      }
    },

    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },

    // PROFILE
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName != null ? JSON.parse(localStorage.getItem("userInfo")).displayName.split('(')[0] : JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    activeUserImg() {
      return (
        JSON.parse(localStorage.getItem("userInfo")).photoURL ||
        this.$store.state.AppActiveUser.img
      );
    }
  },
  methods: {
    handleNtfClick(ntf){
      var self = this;
      var routeData = "";
      
      if(ntf.relatedTableName != "BulkStudentAssignError" && ntf.relatedTableName != "BulkStudentProcess"){
        self.markSingleAsRead(ntf.id);
      }
      if(ntf.relatedTableName == "CourseTaskLog") {
        if (self.$acl.check("Assess"))
          routeData = self.$router.resolve({ path: '/assessor/viewtask', query: { TaskLogId: ntf.key } });
        else if (self.$acl.check("Moderate"))
          routeData = self.$router.resolve({ path: '/moderator/viewtask', query: { TaskLogId: ntf.key } });
          
        window.open(routeData.href, '_blank');
      }
      else if(ntf.relatedTableName == "Video"){
        window.open('../mediapreviewer?videoId=' + ntf.key + '&m=rej', "_blank");
      }
      else if(ntf.relatedTableName == "StudentDocument" || ntf.relatedTableName == "StudentDocumentLogbook"){
        var dropdownEl = document.getElementById("notificationDropdown");
        dropdownEl.click();
        self.$router.push({ path: '/studentDocs', query: { studentDocumentId: ntf.key } });
      }
      else if(ntf.relatedTableName = "BulkStudentProcess"){
        var dropdownEl = document.getElementById("notificationDropdown");
        dropdownEl.click();
        self.$router.push(`/bulkupload-feedback?task=${ntf.key}`);
      }
      else if(ntf.relatedTableName == "BulkStudentAssignError"){
        
        self.loadBulkErrorList(ntf.key)
      }
    },
    backToStudentMenu() {
      this.$router.push("/menu");
    },
    refresh() {
      this.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      this.getNotifications();
    },
    getNotifications() {
      var self = this;
      var onSuccess = response => {
        self.unreadNotifications = response.data;
      };
      var onFinally = response => {
        if(self.unreadNotifications.length > 0) {
          self.$vs.loading.close(self.$refs.mainSidebarPs.$el);
        }
      };
      self.$ajaxGet(self, "Notification/GetUnread", onSuccess, onFinally);
    },
    moderatorToBackEnd(){
      window.location.replace("/mentor-dashboard");
    },
    markAllAsRead() {
      var self = this;
      self.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      var data = {
        ids: self.unreadNotifications.map(function(item) { return item.id })
      };
      var onSuccess = response => {
        self.getNotifications();
      };
      self.$ajaxPost(self, "Notification/MarkAllAsRead", data, onSuccess);
    },
    markSingleAsRead(ntfId) {
      var self = this;
      self.showLoadingOnElement("mainSidebarPs", 0.75, "material");
      var onSuccess = response => {
        self.getNotifications();
      };
      self.$ajaxGet(self, "Notification/MarkSingleAsRead/" + ntfId, onSuccess);
    },
    manualShow() {
      this.popupActive = true;
      if (this.$route.name == "iSpringQuizList")
        this.manualUrl =
          "https://forty5usermanual.azurewebsites.net/doku.php?id=ispringquiz:ispringquiz";
      else if (this.$route.name == "iSpringPresentationList")
        this.manualUrl =
          "https://forty5usermanual.azurewebsites.net/doku.php?id=ispringpresentation:ispringpresentation";
      else if (this.$route.name == "DocumentList")
        this.manualUrl =
          "https://forty5usermanual.azurewebsites.net/doku.php?id=pdfdocument:pdfdocument";
      else if (this.$route.name == "NavigationList")
        this.manualUrl =
          "https://forty5usermanual.azurewebsites.net/doku.php?id=navigationmaps:navigationmaps";
      else if (this.$route.name == "Quiz")
        this.manualUrl =
          "https://forty5usermanual.azurewebsites.net/doku.php?id=quizzes:quizzes";
      else if (this.$route.name == "Course")
        this.manualUrl =
          "https://forty5usermanual.azurewebsites.net/doku.php?id=managecoursesmodules:manage_courses_and_modules";
      else if (this.$route.name == "StudentsList")
        this.manualUrl =
          "https://forty5usermanual.azurewebsites.net/doku.php?id=students:manage_students";
      else
        this.manualUrl = "https://forty5usermanual.azurewebsites.net/doku.php";
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hours " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds > 50 ? `${seconds} sec ago` : "Just Now";
      }

      return "Just Now";
    },
    logout() {
      this.$endUserSession();
      
      let routeData = this.$router.resolve({ path: '/login' });
      window.open(routeData.href, '_self');
      
      this.$acl.change("");
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      localStorage.setItem("isStudent", "false");
    },
    changeSite() {
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      this.$getSites(function() {
        this.$setPermissions(function() {
          this.$acl.change(localStorage.getItem("permissions").split(","));
          this.$router.push("/pages/selectSite");
        });
      });
    },
    outside: function() {
      this.showBookmarkPagesDropdown = false;
    },
    getUserSites() {
      var self = this;
      var onSuccess = response => {
        self.canChangeSite = response.data.length == 1 ? false : true;
      };
      self.$ajaxGet(self, "Role/GetSites", onSuccess);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    viewProfile() {
      if (this.$acl.not.check("Student")) {
        this.$router.push({ name: "Profile" });
      }
    },
    changeTheme(){
      if(themeConfig.theme == "light"){
        this.nameColor = "dark";
        themeConfig.theme = "dark";
        this.$store.dispatch("updateTheme", "dark");
      } else {
        this.nameColor = "light";
        themeConfig.theme = "light";
        this.$store.dispatch("updateTheme", "light");
      }
      
      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
        this.$vs.theme({ primary: JSON.parse(localStorage.getItem("userSiteInfo"))[0].schoolPrimaryColor });
        this.$emit("updateNavbarColorToggle", JSON.parse(localStorage.getItem("userSiteInfo"))[0].schoolPrimaryColor);
        // this.$emit("updateNavbarColor", JSON.parse(localStorage.getItem("userSiteInfo"))[0].navbarColor);
      }
      else{ 
        this.$vs.theme({ primary: JSON.parse(localStorage.getItem("userSiteInfo")).schoolPrimaryColor });
        this.$emit("updateNavbarColorToggle", JSON.parse(localStorage.getItem("userSiteInfo")).schoolPrimaryColor);
        // this.$emit("updateNavbarColor", JSON.parse(localStorage.getItem("userSiteInfo")).navbarColor);
      }
    },
    closeBulkUploadPopup(){
      this.bulkUploadRows = [];
      this.showBulkStudentValidation = false;
    },
    loadBulkErrorList(selectedId){
      var self = this;
      var onSuccess = response =>{
        self.bulkUploadRows = response.data;
        self.showBulkStudentValidation = true;
      }
    
      var onFinally = response =>{
      }
    
      self.$ajaxGet(self, `Company/ShowErrorList?bulkId=${selectedId}` , onSuccess, onFinally);
    },
    changeToTeacher(){
      this.$router.push("/digi/teacher");
    }
  },
  directives: {
    "click-outside": {
      bind: function(el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function(el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    },
    
  },
  mounted() {
    var self = this;
    if (!localStorage.getItem('isStudent') ||  localStorage.getItem('isStudent') != "true") {
      self.getUserSites();
      self.getNotifications();
    }
    this.nameColor = themeConfig.theme
  },
  components: {
    VuePerfectScrollbar,
    draggable
  }
};
</script>
<style lang="scss">
  #notificationDropdown span.feather-icon span.feather-icon-badge {
    background-color: rgba(var(--vs-danger), 1) !important;
  }

  #unReadButton svg.feather.feather.feather-circle {
    position: absolute;
  }

  #readButton svg.feather.feather.feather-check-circle {
    position: absolute;
  }

  #readButton svg.feather.feather.feather-check-circle {
    color: rgb(0, 255, 0);
  }
</style>

<style scoped lang="scss">
    .vx-navbar{
      color: white;
    }
</style>
